import {connect} from 'react-redux';
import {getHighSchoolName} from 'shared/micro-scholarships/selectors';
import PopularActivities from './popular-activities';

export default connect((state) => ({
  institutionName: getHighSchoolName(state),
}))(PopularActivities);
